/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "i går",
        "-2": "i førgår",
        "0": "i dag",
        "1": "i morgon",
        "2": "i overmorgon",
        "future": {
          "one": "om {0} døgn",
          "other": "om {0} døgn"
        },
        "past": {
          "one": "for {0} døgn sidan",
          "other": "for {0} døgn sidan"
        }
      },
      "day-narrow": {
        "-1": "i går",
        "-2": "-2 d.",
        "0": "i dag",
        "1": "i morgon",
        "2": "+2 d.",
        "future": {
          "one": "+{0} d.",
          "other": "+{0} d."
        },
        "past": {
          "one": "–{0} d.",
          "other": "–{0} d."
        }
      },
      "day-short": {
        "-1": "i går",
        "-2": "i forgårs",
        "0": "i dag",
        "1": "i morgon",
        "2": "i overmorgen",
        "future": {
          "one": "om {0} d.",
          "other": "om {0} d."
        },
        "past": {
          "one": "for {0} d. sidan",
          "other": "for {0} d. sidan"
        }
      },
      "hour": {
        "0": "denne timen",
        "future": {
          "one": "om {0} time",
          "other": "om {0} timar"
        },
        "past": {
          "one": "for {0} time sidan",
          "other": "for {0} timar sidan"
        }
      },
      "hour-narrow": {
        "0": "denne timen",
        "future": {
          "one": "+{0} t",
          "other": "+{0} t"
        },
        "past": {
          "one": "–{0} t",
          "other": "–{0} t"
        }
      },
      "hour-short": {
        "0": "denne timen",
        "future": {
          "one": "om {0} t",
          "other": "om {0} t"
        },
        "past": {
          "one": "for {0} t sidan",
          "other": "for {0} t sidan"
        }
      },
      "minute": {
        "0": "dette minuttet",
        "future": {
          "one": "om {0} minutt",
          "other": "om {0} minutt"
        },
        "past": {
          "one": "for {0} minutt sidan",
          "other": "for {0} minutt sidan"
        }
      },
      "minute-narrow": {
        "0": "dette minuttet",
        "future": {
          "one": "+{0} min",
          "other": "+{0} min"
        },
        "past": {
          "one": "–{0} min",
          "other": "–{0} min"
        }
      },
      "minute-short": {
        "0": "dette minuttet",
        "future": {
          "one": "om {0} min",
          "other": "om {0} min"
        },
        "past": {
          "one": "for {0} min sidan",
          "other": "for {0} min sidan"
        }
      },
      "month": {
        "-1": "førre månad",
        "0": "denne månaden",
        "1": "neste månad",
        "future": {
          "one": "om {0} månad",
          "other": "om {0} månadar"
        },
        "past": {
          "one": "for {0} månad sidan",
          "other": "for {0} månadar sidan"
        }
      },
      "month-narrow": {
        "-1": "førre md.",
        "0": "denne md.",
        "1": "neste md.",
        "future": {
          "one": "+{0} md.",
          "other": "+{0} md."
        },
        "past": {
          "one": "–{0} md.",
          "other": "–{0} md."
        }
      },
      "month-short": {
        "-1": "førre md.",
        "0": "denne md.",
        "1": "neste md.",
        "future": {
          "one": "om {0} md.",
          "other": "om {0} md."
        },
        "past": {
          "one": "for {0} md. sidan",
          "other": "for {0} md. sidan"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "førre kvartal",
        "0": "dette kvartalet",
        "1": "neste kvartal",
        "future": {
          "one": "om {0} kvartal",
          "other": "om {0} kvartal"
        },
        "past": {
          "one": "for {0} kvartal sidan",
          "other": "for {0} kvartal sidan"
        }
      },
      "quarter-narrow": {
        "-1": "forrige kv.",
        "0": "dette kv.",
        "1": "neste kv.",
        "future": {
          "one": "+{0} kv.",
          "other": "+{0} kv."
        },
        "past": {
          "one": "–{0} kv.",
          "other": "–{0} kv."
        }
      },
      "quarter-short": {
        "-1": "forrige kv.",
        "0": "dette kv.",
        "1": "neste kv.",
        "future": {
          "one": "om {0} kv.",
          "other": "om {0} kv."
        },
        "past": {
          "one": "for {0} kv. sidan",
          "other": "for {0} kv. sidan"
        }
      },
      "second": {
        "0": "no",
        "future": {
          "one": "om {0} sekund",
          "other": "om {0} sekund"
        },
        "past": {
          "one": "for {0} sekund sidan",
          "other": "for {0} sekund sidan"
        }
      },
      "second-narrow": {
        "0": "nå",
        "future": {
          "one": "+{0} s",
          "other": "+{0} s"
        },
        "past": {
          "one": "–{0} s",
          "other": "–{0} s"
        }
      },
      "second-short": {
        "0": "nå",
        "future": {
          "one": "om {0} sek",
          "other": "om {0} sek"
        },
        "past": {
          "one": "for {0} sek sidan",
          "other": "for {0} sek sidan"
        }
      },
      "week": {
        "-1": "førre veke",
        "0": "denne veka",
        "1": "neste veke",
        "future": {
          "one": "om {0} veke",
          "other": "om {0} veker"
        },
        "past": {
          "one": "for {0} veke sidan",
          "other": "for {0} veker sidan"
        }
      },
      "week-narrow": {
        "-1": "førre veke",
        "0": "denne veka",
        "1": "neste veke",
        "future": {
          "one": "+{0} v.",
          "other": "+{0} v."
        },
        "past": {
          "one": "–{0} v.",
          "other": "–{0} v."
        }
      },
      "week-short": {
        "-1": "førre veke",
        "0": "denne veka",
        "1": "neste veke",
        "future": {
          "one": "om {0} v.",
          "other": "om {0} v."
        },
        "past": {
          "one": "for {0} v. sidan",
          "other": "for {0} v. sidan"
        }
      },
      "year": {
        "-1": "i fjor",
        "0": "i år",
        "1": "neste år",
        "future": {
          "one": "om {0} år",
          "other": "om {0} år"
        },
        "past": {
          "one": "for {0} år sidan",
          "other": "for {0} år sidan"
        }
      },
      "year-narrow": {
        "-1": "i fjor",
        "0": "i år",
        "1": "neste år",
        "future": {
          "one": "om {0} år",
          "other": "om {0} år"
        },
        "past": {
          "one": "for {0} år sidan",
          "other": "for {0} år sidan"
        }
      },
      "year-short": {
        "-1": "i fjor",
        "0": "i år",
        "1": "neste år",
        "future": {
          "one": "om {0} år",
          "other": "om {0} år"
        },
        "past": {
          "one": "for {0} år sidan",
          "other": "for {0} år sidan"
        }
      }
    },
    "locale": "nn"
  });
}